import {useEffect, useState} from 'react';
import {createClient} from '@supabase/supabase-js';

const supabase = createClient('https://slnjqaogmpqwlxinplar.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNsbmpxYW9nbXBxd2x4aW5wbGFyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDQ2Mjk5NDYsImV4cCI6MjAyMDIwNTk0Nn0.zAAesrAtDXCsbdsU_i5k68FWOZYiR7TlbgtmDgstlqs');

function SupabaseTestPage() {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    // console.log("SupabaseTestPage useEffect")
    // getCountriesFetch()
    getCountries();
  }, []);

  async function getCountries() {
    // const activityResp = await supabase
    //     .from('activity')
    //     .select()
    // const pollsResp = await supabase
    //     .from('polls')
    //     .select()

    const joinResp = await supabase
      .from('polls')
      .select("*, activity!inner(poll_id)")
      .eq("activity.isAnswered", 'false')
      .or('and("activity.isAnswered.is.null")')

    // const tempViewResp = await supabase.from('unanswered_polls').select()

    // .or("activity.isAnswered", "")


    console.log('resp tempViewResp', joinResp)
    // console.log('resp activityResp', activityResp)
    // console.log('resp pollsResp', pollsResp)
    // setCountries(activityResp.data);
  }

  return (
    <ul>
      {countries.map((country) => (
        <li key={country.name}>{country.name}</li>
      ))}
    </ul>
  );
}

export default SupabaseTestPage;
